export interface UserDetailType {
  fullName: string;
  profilePicUrl: string;
  shortBio: string;
  userName: string;
  user_id: string;
  is_creator: boolean;
}

export interface CommentType {
  docId: string;
  comment: {
    comment_body: string,
    commenter_type: string,
    row_created: string,
  }[];
  createdAt: string;
  level: number;
  like_counts: number;
  parent_reply_id?: string;
  parent_comment_id: string;
  parent_post_id: string;
  reply_counts: number;
  comments_list?: CommentType[];
  share_counts?: number;
  updatedAt: string;
  user_id: string;
  watch?: number;
  isThinking?: boolean;
  user_details?: UserDetailType;
  is_liked?: boolean;
  is_requester_following?: boolean;
  show_typing?: boolean;
  flat_comments_list?: string[];
  page_no?: number;
}

export interface PostType {
  docId: string;
  createdAt?: string;
  comments_counts: number;
  comments_list?: CommentType[];
  content: {
    content_body: string,
    row_created: string,
  }[];
  images: string[];
  like_counts: number;
  share_counts?: number;
  updatedAt: string;
  user_id: string;
  watch?: number;
  post_user_details?: UserDetailType;
  is_liked?: boolean;
  is_requester_following?: boolean;
  flat_comments_list?: string[];
  page_no?: number;
  link?: string;
  article_id?: string;
}

export interface PaginationType {
  current_page: number;
  has_next: boolean;
  has_previous: boolean;
  next_page: number;
  per_page: number;
  previous_page: number;
}

export interface PaginatedPosts {
  pagination: PaginationType;
  posts: PostType[];
}

export interface FeedType {
  pageParams: number[];
  pages: FlattenedFeedType[];
}

export interface PaginatedComments {
  pagination: PaginationType;
  comments: CommentType[];
}

export interface PostDetailsType {
  pageParams: number[];
  pages: PaginatedComments[];
}

export interface FlattenedFeedType {
  pagination: PaginationType;
  posts: Record<string, PostType>;        // posts store
  comments: Record<string, CommentType>;  // comments store
  orderedPosts: string[];                 // store ids for maintaining order
  orderedComments?: string[];
}

export type FeedNames =
  ['memesCommunity', string, boolean] |
  ['memesFromFollowing', string] |
  ['memesNews', string] |
  ['memeDetails', string] |
  ['userPosts', string] |
  ['userReplies', string];

export const MODERATION_ERROR = 'Content is not safe.';
